import { Component, Input } from '@angular/core';
import { MenuFooterComponent } from '../../../menu/building-blocks/menu-footer/menu-footer.component';
import type { MarketingMenu } from '../../../../../../../models/menu/marketing-menu';

@Component({
  selector: 'app-marketing-footer',
  templateUrl: './marketing-footer.component.html',
  standalone: false
})
export class MarketingFooterComponent extends MenuFooterComponent {
  @Input() menu: MarketingMenu;
}
